import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy typo slug — permanently redirect to the correct doctor page.
export const Route = createFileRoute("/doctors/dr-fahad-juboorib")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/doctors/dr-fahad-juboori/", location.searchStr), statusCode: 301 });
  },
});
